import { CALL_API } from "redux-api-middleware";
import { qa } from "apis/qualityAssurance";
import { ho } from "apis/homeowner/ho";
import employeeApi from "apis/employee";
import {
  REQUEST_QA_CASE,
  RECEIVE_QA_CASE,
  ERROR_QA_CASE,
  REQUEST_QA_CASE_INFO,
  RECEIVE_QA_CASE_INFO,
  ERROR_QA_CASE_INFO,
  REQUEST_QA_CASE_RETURN,
  RECEIVE_QA_CASE_RETURN,
  ERROR_QA_CASE_RETURN,
  REQUEST_QA_CASE_SEND,
  RECEIVE_QA_CASE_SEND,
  ERROR_QA_CASE_SEND,
  REQUEST_QA_CASE_COMPLETE,
  RECEIVE_QA_CASE_COMPLETE,
  ERROR_QA_CASE_COMPLETE,
  REQUEST_TIMELOGBYDAY_SUMMARY,
  RECEIVE_TIMELOGBYDAY_SUMMARY,
  ERROR_TIMELOGBYDAY_SUMMARY,
  SET_QA_READY,
  SET_QA_STARTED,
  SET_QA_PAUSED,
  SET_QA_VALIDATION_ERRORS,
  SET_QA_SUMMARYVIEW_ENABLED,
  SET_QA_KEEP_GETTING_CASES,
  SET_QA_SHOW_REJECT_DIALOG,
  SET_QA_SWITCH_CASE_DIALOG,
  SET_QA_SHOW_SEND_MANAGER_DIALOG,
  SET_QA_SHOW_COMPLETED_CASE_DIALOG,
  SET_QA_COMPLETING_CASE,
  SET_QA_REJECTING_CASE,
  SET_QA_ESCALATING_CASE,
  SET_QA_VIEW_SAVE_DATA,
  RESET_QA_STATE,
  SET_QA_TIMESPENT,
  REQUEST_QA_SKETCH,
  RECEIVE_QA_SKETCH,
  ERROR_QA_SKETCH,
  REQUEST_QA_RCT,
  RECEIVE_QA_RCT,
  ERROR_QA_RCT,
  REQUEST_360_VALUE,
  RECEIVE_360_VALUE,
  ERROR_360_VALUE,
  REQUEST_CASE_ALERTS,
  RECEIVE_CASE_ALERTS,
  ERROR_CASE_ALERTS,
  REQUEST_QA_MANAGERS,
  RECEIVE_QA_MANAGERS,
  ERROR_QA_MANAGERS,
  UPDATE_QA_REDUX_CASEINFO,
  REQUEST_CASETIMELOG_ADD,
  RECEIVE_CASETIMELOG_ADD,
  ERROR_CASETIMELOG_ADD,
  PHOENIX_RCT_NEEDS_COMMIT,
  REQUEST_CASE_HAZARDS,
  RECEIVE_CASE_HAZARDS,
  ERROR_CASE_HAZARDS,
  RESET_QA_CASE,
  REQUEST_QA_ASSIGNABLE_USERS,
  RECEIVE_QA_ASSIGNABLE_USERS,
  ERROR_QA_ASSIGNABLE_USERS,
  SET_QA_TIMER_INFO,
  REQUEST_E2VALUE,
  RECEIVE_E2VALUE,
  ERROR_E2VALUE,
} from "typeConstants";
import responseHandler from "responseHandler";
import { WebApiReduxRequest,  HTTP_GET, HTTP_POST, WebApiReduxRequestWithCallback,  } from "tools/webservice";
import * as employeeRoles from "typeConstants/employeeRoles";

///API CALLS
const getNextCase = (req, callback) => {
  return callRPC(
    REQUEST_QA_CASE,
    RECEIVE_QA_CASE,
    ERROR_QA_CASE,
    "next-case",
    req,
    callback
  );
};
const getCaseInfo = (controlIdNumber, callback) => WebApiReduxRequestWithCallback(
  REQUEST_QA_CASE_INFO,
  RECEIVE_QA_CASE_INFO,
  ERROR_QA_CASE_INFO,
  HTTP_GET,
  `/qa/case-info/${controlIdNumber}`,
  callback
 );
const returnCase = (req, callback) => {
  return callRPC(
    REQUEST_QA_CASE_RETURN,
    RECEIVE_QA_CASE_RETURN,
    ERROR_QA_CASE_RETURN,
    "reject-case",
    req,
    callback,
  );
};
const sendToManager = (req, callback) => {
  return callRPC(
    REQUEST_QA_CASE_SEND,
    RECEIVE_QA_CASE_SEND,
    ERROR_QA_CASE_SEND,
    "send-case-to-manager",
    req,
    callback
  );
};
const sendToAgent = (req, callback) => {
  return callRPC(
    REQUEST_QA_CASE_SEND,
    RECEIVE_QA_CASE_SEND,
    ERROR_QA_CASE_SEND,
    "send-case-to-agent",
    req,
    callback
  );
};
const completeCase = (req, callback) => {
  return callRPC(
    REQUEST_QA_CASE_COMPLETE,
    RECEIVE_QA_CASE_COMPLETE,
    ERROR_QA_CASE_COMPLETE,
    "complete-case",
    req,
    callback
  );
};
const getCaseSketch = (req, callback) => {
  return callRPC(
    REQUEST_QA_SKETCH,
    RECEIVE_QA_SKETCH,
    ERROR_QA_SKETCH,
    "case-sketch",
    req,
    callback
  );
};
const getCaseRCT = (req, callback) => {
  return callRPC(
    REQUEST_QA_RCT,
    RECEIVE_QA_RCT,
    ERROR_QA_RCT,
    "case-rct",
    req,
    callback
  );
};

const callRPC = (REQ, REC, ERR, method, payload, callback) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: qa.endpoint(method),
        method: HTTP_POST,
        body: JSON.stringify(payload),
        types: [
          REQ,
          {
            type: REC,
            payload: (action, state, res) =>
              res.json().then(data => {
                setTimeout(() => {
                  if (data.messages && data.messages.length > 0) {
                    responseHandler.success(data.messages.join(", "), dispatch);
                  }
                  if (callback) {
                    callback(data);
                  }
                }, 0);
                return data;
              })
          },
          {
            type: ERR,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              setTimeout(() => {
                if (callback) {
                  callback();
                }
              }, 0);
            }
          }
        ]
      }
    });
  };
};

const getTimeLogByDaySummary = (internetUserId, payPeriodId) => {
  return dispatch => {
    dispatch({
      [CALL_API]:
      {
        endpoint: qa.getTimeLogByDaySummary(internetUserId, payPeriodId),
        method: HTTP_GET,
        types: [
          REQUEST_TIMELOGBYDAY_SUMMARY,
          {
            type: RECEIVE_TIMELOGBYDAY_SUMMARY,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          },
          {
            type: ERROR_TIMELOGBYDAY_SUMMARY,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};
///REDUX STORE STATE SETTING
const setQAReady = isQAReady => {
  return {
    type: SET_QA_READY,
    payload: isQAReady
  };
};

const setQAStarted = isQAStarted => {
  return {
    type: SET_QA_STARTED,
    payload: isQAStarted
  };
};

const setQAPaused = isQAPaused => {
  return {
    type: SET_QA_PAUSED,
    payload: isQAPaused
  };
};

const setQAValidationErrors = qaValidationErrors => {
  return {
    type: SET_QA_VALIDATION_ERRORS,
    payload: qaValidationErrors
  };
};

const setQASummaryViewEnabled = isQASummaryViewEnabled => {
  return {
    type: SET_QA_SUMMARYVIEW_ENABLED,
    payload: isQASummaryViewEnabled
  };
};

const setQAKeepGettingCases = shouldQAKeepGettingCases => {
  return {
    type: SET_QA_KEEP_GETTING_CASES,
    payload: shouldQAKeepGettingCases
  };
};

const setQAShowRejectDialog = shouldShowRejectDialog => {
  return {
    type: SET_QA_SHOW_REJECT_DIALOG,
    payload: shouldShowRejectDialog
  };
};

const setQASwitchCaseDialog = (shouldShowDialog, controlNumber) => {
  return {
    type: SET_QA_SWITCH_CASE_DIALOG,
    payload: { shouldShowDialog, controlNumber }
  };
};

const setQAShowSendManagerDialog = shouldShowManagerDialog => {
  return {
    type: SET_QA_SHOW_SEND_MANAGER_DIALOG,
    payload: shouldShowManagerDialog
  };
};

const setQAShowCompletedCaseDialog = shouldShowCompletedCaseDialog => {
  return {
    type: SET_QA_SHOW_COMPLETED_CASE_DIALOG,
    payload: shouldShowCompletedCaseDialog
  };
};

const setQACompletingCase = isCompletingCase => {
  return {
    type: SET_QA_COMPLETING_CASE,
    payload: isCompletingCase
  };
};

const setQARejectingCase = isRejectingCase => {
  return {
    type: SET_QA_REJECTING_CASE,
    payload: isRejectingCase
  };
};

const setQAEscalatingCase = isEscalatingCase => {
  return {
    type: SET_QA_ESCALATING_CASE,
    payload: isEscalatingCase
  };
};

const setQASaveDataFunction = qaSaveDataFunction => {
  return {
    type: SET_QA_VIEW_SAVE_DATA,
    payload: qaSaveDataFunction
  };
};

const resetQAState = () => {
  return {
    type: RESET_QA_STATE
  };  
};

const resetQACase = (callBack) => {
  return dispatch => {
    dispatch({
      type: RESET_QA_CASE,
    }).then(callBack);
  };    
};

const setQATimeSpent = (qaTimeSpent, callBack = null) => {
  return dispatch => {
    dispatch({
      type: SET_QA_TIMESPENT,
      payload: qaTimeSpent
    }).then(callBack);
  };
};

const setQATimerInfo = (timerId, timerPingIntervalSeconds) => {
  return dispatch => {
    dispatch({
      type: SET_QA_TIMER_INFO,
      payload: { timerId: timerId, timerPingIntervalSeconds: timerPingIntervalSeconds },
    });
  };
};

const setPhoenixRctCommitStatus = status => {
  return {
    type: PHOENIX_RCT_NEEDS_COMMIT,
    payload: status
  };
};

const get360Value = controlNumber => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: qa.get360Value(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_360_VALUE,
          {
            type: RECEIVE_360_VALUE,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_360_VALUE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};
const getHasE2Value = controlNumber => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: `/qa/${controlNumber}/e2Value`,
        method: HTTP_GET,
        types: [
          REQUEST_E2VALUE,
          {
            type: RECEIVE_E2VALUE,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_E2VALUE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};
const getCaseAlerts = () => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: qa.getCaseAlerts(),
        method: HTTP_GET,
        types: [
          REQUEST_CASE_ALERTS,
          {
            type: RECEIVE_CASE_ALERTS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_CASE_ALERTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
};

const getManagers = () => WebApiReduxRequest(REQUEST_QA_MANAGERS, RECEIVE_QA_MANAGERS, ERROR_QA_MANAGERS, HTTP_GET, employeeApi.getManagersByEmployeeRoles([employeeRoles.BUSOP_AGENT, employeeRoles.VALUATION_QUALITY_ASSOCIATE, employeeRoles.QUALITY_COMPLIANCE_AUDITOR]));

const updateQAReduxCaseInfo = (newCaseInfo) => {
  return {
    type: UPDATE_QA_REDUX_CASEINFO,
    payload: newCaseInfo
  };
};

const addReviewCaseTimeLog = (newCaseTimeLog, displayResponse = true, callback = null) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: qa.addTimeLog(),
        method: HTTP_POST,
        body: JSON.stringify(newCaseTimeLog),
        types: [
          REQUEST_CASETIMELOG_ADD,
          {
            type: RECEIVE_CASETIMELOG_ADD,
            payload: (action, state, res) => {
              res.json()
                .then(data => {
                  if (displayResponse) {
                    setTimeout(() => {
                      let message = "Case Time Log Added";
                      responseHandler.success(message, dispatch);
                    }, 0);
                  }
                  return data;
                });
            }
          },
          {
            type: ERROR_CASETIMELOG_ADD,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return addReviewCaseTimeLog;
            }
          }
        ]
      }
    }).then(callback)
  );
};

const getCaseHazards = (controlNumber) => WebApiReduxRequest(
  REQUEST_CASE_HAZARDS,
  RECEIVE_CASE_HAZARDS,
  ERROR_CASE_HAZARDS,
  HTTP_GET,
  ho.getCaseHazards(controlNumber)
);

const getAssignableUsers = () => WebApiReduxRequest(
  REQUEST_QA_ASSIGNABLE_USERS,
  RECEIVE_QA_ASSIGNABLE_USERS,
  ERROR_QA_ASSIGNABLE_USERS,
  HTTP_GET,
  qa.assignableUsers(),
);

export {
  getNextCase,
  getCaseInfo,
  returnCase,
  sendToManager,
  completeCase,
  getTimeLogByDaySummary,
  setQAReady,
  setQAStarted,
  setQAPaused,
  setQAValidationErrors,
  setQASummaryViewEnabled,
  setQAKeepGettingCases,
  setQAShowRejectDialog,
  setQAShowSendManagerDialog,
  setQAShowCompletedCaseDialog,
  setQASwitchCaseDialog,
  setQACompletingCase,
  setQARejectingCase,
  setQAEscalatingCase,
  setQASaveDataFunction,
  resetQAState,
  setQATimeSpent,
  getCaseSketch,
  getCaseRCT,
  get360Value,
  getHasE2Value,
  getCaseAlerts,
  getManagers,
  updateQAReduxCaseInfo,
  sendToAgent,
  addReviewCaseTimeLog,
  setPhoenixRctCommitStatus,
  getCaseHazards,
  resetQACase,
  getAssignableUsers,
  setQATimerInfo,
};
